var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    {
      staticClass: "full-width no-padding-top",
      class: { "no-goals": _vm.no_goals },
      attrs: { id: "goals-settings" }
    },
    [
      _c("div", { staticClass: "container" }, [
        _vm._m(0),
        _vm._v(" "),
        !_vm.questionnaire
          ? _c(
              "div",
              {
                staticClass: "row progress",
                attrs: { id: "goal-progress-wrapper" }
              },
              [
                _c(
                  "div",
                  { staticClass: "col-12" },
                  [
                    _c("h3", [_vm._v("This week's progress")]),
                    _vm._v(" "),
                    _c("goal-progress", { ref: "goal-progress" })
                  ],
                  1
                )
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.questionnaire,
                expression: "!questionnaire"
              }
            ],
            staticClass: "row goal question",
            attrs: { id: "set-goals-question" }
          },
          [
            _c("div", { staticClass: "col-12" }, [
              _c("h3", [_vm._v("Would you like to opt out of goals?")]),
              _vm._v(" "),
              _c("div", { staticClass: "inline-fields" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.no_goals,
                      expression: "no_goals"
                    }
                  ],
                  attrs: { type: "checkbox" },
                  domProps: {
                    checked: Array.isArray(_vm.no_goals)
                      ? _vm._i(_vm.no_goals, null) > -1
                      : _vm.no_goals
                  },
                  on: {
                    change: function($event) {
                      var $$a = _vm.no_goals,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 && (_vm.no_goals = $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            (_vm.no_goals = $$a
                              .slice(0, $$i)
                              .concat($$a.slice($$i + 1)))
                        }
                      } else {
                        _vm.no_goals = $$c
                      }
                    }
                  }
                }),
                _c("label", [_vm._v("I don't want to set goals")])
              ])
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.questionnaire || _vm.question === 1,
                expression: "!questionnaire || question === 1"
              }
            ],
            staticClass: "row goal question"
          },
          [
            _c("div", { staticClass: "col-12" }, [
              _c("h3", [_vm._v("My food prep goal")]),
              _vm._v(" "),
              _c("div", { staticClass: "goal-input-wrapper" }, [
                _c("div", { staticClass: "text" }, [_vm._v("I want to cook")]),
                _vm._v(" "),
                _c("div", { staticClass: "input" }, [
                  _c(
                    "button",
                    {
                      staticClass: "input-control input-down",
                      attrs: { disabled: _vm.thinking },
                      on: {
                        click: function($event) {
                          return _vm.decrease_recipe_goal()
                        }
                      }
                    },
                    [_vm._v("-")]
                  ),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.number",
                        value: _vm.recipe_goal,
                        expression: "recipe_goal",
                        modifiers: { number: true }
                      }
                    ],
                    staticClass: "goal-input",
                    attrs: {
                      type: "number",
                      step: "1",
                      max: "this.weekly_limit",
                      min: "0"
                    },
                    domProps: { value: _vm.recipe_goal },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.recipe_goal = _vm._n($event.target.value)
                      },
                      blur: function($event) {
                        return _vm.$forceUpdate()
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "input-control input-up",
                      attrs: { disabled: _vm.thinking },
                      on: {
                        click: function($event) {
                          return _vm.increase_recipe_goal()
                        }
                      }
                    },
                    [_vm._v("+")]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "text" }, [_vm._v("times a week")])
              ])
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.questionnaire || _vm.question === 2,
                expression: "!questionnaire || question === 2"
              }
            ],
            staticClass: "row goal question"
          },
          [
            _c("div", { staticClass: "col-12" }, [
              _c("h3", [_vm._v("I want to exercise on these days:")]),
              _vm._v(" "),
              _c("div", { staticClass: "goal-input-wrapper" }),
              _vm._v(" "),
              _c("div", { staticClass: "day-selection-wrapper" }, [
                _c("div", { staticClass: "day" }, [
                  _c("label", [_vm._v("M")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.exercise_goal.mon,
                        expression: "exercise_goal.mon"
                      }
                    ],
                    attrs: { type: "checkbox" },
                    domProps: {
                      checked: Array.isArray(_vm.exercise_goal.mon)
                        ? _vm._i(_vm.exercise_goal.mon, null) > -1
                        : _vm.exercise_goal.mon
                    },
                    on: {
                      change: function($event) {
                        var $$a = _vm.exercise_goal.mon,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.exercise_goal,
                                "mon",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.exercise_goal,
                                "mon",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(_vm.exercise_goal, "mon", $$c)
                        }
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "day" }, [
                  _c("label", [_vm._v("T")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.exercise_goal.tues,
                        expression: "exercise_goal.tues"
                      }
                    ],
                    attrs: { type: "checkbox" },
                    domProps: {
                      checked: Array.isArray(_vm.exercise_goal.tues)
                        ? _vm._i(_vm.exercise_goal.tues, null) > -1
                        : _vm.exercise_goal.tues
                    },
                    on: {
                      change: function($event) {
                        var $$a = _vm.exercise_goal.tues,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.exercise_goal,
                                "tues",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.exercise_goal,
                                "tues",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(_vm.exercise_goal, "tues", $$c)
                        }
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "day" }, [
                  _c("label", [_vm._v("W")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.exercise_goal.wed,
                        expression: "exercise_goal.wed"
                      }
                    ],
                    attrs: { type: "checkbox" },
                    domProps: {
                      checked: Array.isArray(_vm.exercise_goal.wed)
                        ? _vm._i(_vm.exercise_goal.wed, null) > -1
                        : _vm.exercise_goal.wed
                    },
                    on: {
                      change: function($event) {
                        var $$a = _vm.exercise_goal.wed,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.exercise_goal,
                                "wed",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.exercise_goal,
                                "wed",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(_vm.exercise_goal, "wed", $$c)
                        }
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "day" }, [
                  _c("label", [_vm._v("T")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.exercise_goal.thurs,
                        expression: "exercise_goal.thurs"
                      }
                    ],
                    attrs: { type: "checkbox" },
                    domProps: {
                      checked: Array.isArray(_vm.exercise_goal.thurs)
                        ? _vm._i(_vm.exercise_goal.thurs, null) > -1
                        : _vm.exercise_goal.thurs
                    },
                    on: {
                      change: function($event) {
                        var $$a = _vm.exercise_goal.thurs,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.exercise_goal,
                                "thurs",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.exercise_goal,
                                "thurs",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(_vm.exercise_goal, "thurs", $$c)
                        }
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "day" }, [
                  _c("label", [_vm._v("F")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.exercise_goal.fri,
                        expression: "exercise_goal.fri"
                      }
                    ],
                    attrs: { type: "checkbox" },
                    domProps: {
                      checked: Array.isArray(_vm.exercise_goal.fri)
                        ? _vm._i(_vm.exercise_goal.fri, null) > -1
                        : _vm.exercise_goal.fri
                    },
                    on: {
                      change: function($event) {
                        var $$a = _vm.exercise_goal.fri,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.exercise_goal,
                                "fri",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.exercise_goal,
                                "fri",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(_vm.exercise_goal, "fri", $$c)
                        }
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "day" }, [
                  _c("label", [_vm._v("S")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.exercise_goal.sat,
                        expression: "exercise_goal.sat"
                      }
                    ],
                    attrs: { type: "checkbox" },
                    domProps: {
                      checked: Array.isArray(_vm.exercise_goal.sat)
                        ? _vm._i(_vm.exercise_goal.sat, null) > -1
                        : _vm.exercise_goal.sat
                    },
                    on: {
                      change: function($event) {
                        var $$a = _vm.exercise_goal.sat,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.exercise_goal,
                                "sat",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.exercise_goal,
                                "sat",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(_vm.exercise_goal, "sat", $$c)
                        }
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "day" }, [
                  _c("label", [_vm._v("S")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.exercise_goal.sun,
                        expression: "exercise_goal.sun"
                      }
                    ],
                    attrs: { type: "checkbox" },
                    domProps: {
                      checked: Array.isArray(_vm.exercise_goal.sun)
                        ? _vm._i(_vm.exercise_goal.sun, null) > -1
                        : _vm.exercise_goal.sun
                    },
                    on: {
                      change: function($event) {
                        var $$a = _vm.exercise_goal.sun,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.exercise_goal,
                                "sun",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.exercise_goal,
                                "sun",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(_vm.exercise_goal, "sun", $$c)
                        }
                      }
                    }
                  })
                ])
              ])
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.questionnaire || _vm.question === 3,
                expression: "!questionnaire || question === 3"
              }
            ],
            staticClass: "row goal question"
          },
          [
            _c("div", { staticClass: "col-12" }, [
              _c("h3", [
                _vm._v("I would like to try these type of exercises:")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "exercise-preference-wrapper" }, [
                _c("div", { staticClass: "inline-fields" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.exercise_prefs.pilates,
                        expression: "exercise_prefs.pilates"
                      }
                    ],
                    attrs: { type: "checkbox" },
                    domProps: {
                      checked: Array.isArray(_vm.exercise_prefs.pilates)
                        ? _vm._i(_vm.exercise_prefs.pilates, null) > -1
                        : _vm.exercise_prefs.pilates
                    },
                    on: {
                      change: function($event) {
                        var $$a = _vm.exercise_prefs.pilates,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.exercise_prefs,
                                "pilates",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.exercise_prefs,
                                "pilates",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(_vm.exercise_prefs, "pilates", $$c)
                        }
                      }
                    }
                  }),
                  _c("label", [_vm._v("Pilates")])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "inline-fields" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.exercise_prefs.yoga,
                        expression: "exercise_prefs.yoga"
                      }
                    ],
                    attrs: { type: "checkbox" },
                    domProps: {
                      checked: Array.isArray(_vm.exercise_prefs.yoga)
                        ? _vm._i(_vm.exercise_prefs.yoga, null) > -1
                        : _vm.exercise_prefs.yoga
                    },
                    on: {
                      change: function($event) {
                        var $$a = _vm.exercise_prefs.yoga,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.exercise_prefs,
                                "yoga",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.exercise_prefs,
                                "yoga",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(_vm.exercise_prefs, "yoga", $$c)
                        }
                      }
                    }
                  }),
                  _c("label", [_vm._v("Yoga")])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "inline-fields" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.exercise_prefs.bounce,
                        expression: "exercise_prefs.bounce"
                      }
                    ],
                    attrs: { type: "checkbox" },
                    domProps: {
                      checked: Array.isArray(_vm.exercise_prefs.bounce)
                        ? _vm._i(_vm.exercise_prefs.bounce, null) > -1
                        : _vm.exercise_prefs.bounce
                    },
                    on: {
                      change: function($event) {
                        var $$a = _vm.exercise_prefs.bounce,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.exercise_prefs,
                                "bounce",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.exercise_prefs,
                                "bounce",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(_vm.exercise_prefs, "bounce", $$c)
                        }
                      }
                    }
                  }),
                  _c("label", [_vm._v("Strength")])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "inline-fields" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.exercise_prefs.strength,
                        expression: "exercise_prefs.strength"
                      }
                    ],
                    attrs: { type: "checkbox" },
                    domProps: {
                      checked: Array.isArray(_vm.exercise_prefs.strength)
                        ? _vm._i(_vm.exercise_prefs.strength, null) > -1
                        : _vm.exercise_prefs.strength
                    },
                    on: {
                      change: function($event) {
                        var $$a = _vm.exercise_prefs.strength,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.exercise_prefs,
                                "strength",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.exercise_prefs,
                                "strength",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(_vm.exercise_prefs, "strength", $$c)
                        }
                      }
                    }
                  }),
                  _c("label", [_vm._v("Bounce")])
                ])
              ])
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.questionnaire || _vm.question === 4,
                expression: "!questionnaire || question === 4"
              }
            ],
            staticClass: "row goal question"
          },
          [
            _c("div", { staticClass: "col-12" }, [
              _c("h3", [_vm._v("What do you need the most support with?")]),
              _vm._v(" "),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.support_prefs,
                      expression: "support_prefs"
                    }
                  ],
                  staticClass: "core-prevent-select2 select-css",
                  on: {
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.support_prefs = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    }
                  }
                },
                [
                  _c("option", { attrs: { disabled: "", value: "" } }, [
                    _vm._v("Please select one")
                  ]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "emotional-eating" } }, [
                    _vm._v("Emotional eating")
                  ]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "cravings" } }, [
                    _vm._v("Cravings")
                  ]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "body-image" } }, [
                    _vm._v("Body image")
                  ]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "getting-fit" } }, [
                    _vm._v("Getting fit and strong")
                  ]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "low-energy" } }, [
                    _vm._v("Low energy")
                  ])
                ]
              )
            ])
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12" }, [
            _vm.questionnaire && this.question <= this.numberOfQuestions
              ? _c(
                  "button",
                  {
                    staticClass: "core-btn",
                    attrs: { disabled: _vm.thinking },
                    on: {
                      click: function($event) {
                        return _vm.prevQuestion()
                      }
                    }
                  },
                  [_vm._v("Previous")]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.questionnaire && this.question <= this.numberOfQuestions
              ? _c(
                  "button",
                  {
                    staticClass: "core-btn",
                    attrs: { disabled: _vm.thinking },
                    on: {
                      click: function($event) {
                        return _vm.nextQuestion()
                      }
                    }
                  },
                  [_vm._v("Next")]
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.questionnaire
              ? _c(
                  "button",
                  {
                    staticClass: "core-btn",
                    attrs: { disabled: _vm.thinking },
                    on: {
                      click: function($event) {
                        return _vm.saveGoals()
                      }
                    }
                  },
                  [_vm._v("Save goals")]
                )
              : _vm._e()
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row heading" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("h2", [_vm._v("My health goals")])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }